<template>
  <v-overlay :value="shower" absolute opacity="0.1">
    <img height="250" width="250" :src="require('@/assets/search.gif')" />
    <div class="text-center;" style="text-align: center">
      <v-chip class="px-2" color="white"
        ><b style="color: #12395f">
          {{ $t("searchdocument.dowloadind_data") }}</b
        ></v-chip
      >
    </div>
  </v-overlay>
</template>
<script>
export default {
  name: "portal_overlay_seacrh",
  data: () => ({
    shower: true,
  }),
};
</script>